<template>
  <div v-if="isPickLanguageActiveLocal">
    <div class="vx-row">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text remove-shadow" style="background-color: transparent">
                <span><feather-icon class="pt-2" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike text__school-font-color"
              type="filled"
              color="">
              Select a Language
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-0">
      <div class="vx-row">
        <div class="vx-col" v-for="(_language, index) in languages" :key="index">
          <vx-card class="mb-4 glow-effect_dark fixed-width_languages card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-2" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                style="border-radius:0 7px 7px 0;"
                @click="selectLanguage(_language)">
                {{ _language }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPickLanguageActive: {
      type: Boolean,
      required: true
    },
    languages: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    isPickLanguageActiveLocal: {
      get() {
        return this.isPickLanguageActive;
      }
    }
  },
  methods: {
    selectLanguage(language) {
      this.$emit("languageSelected", language);
    }
  },
  mounted() {
    
  }
};
</script>